import * as React from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import { Grid, Typography } from '@mui/material';

export default function ColorshadeMeaning() {
  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        '& > :not(style)': {
          m: 1,
          width: '100%',
          height: '100vh',
        },
      }}
    
    >
      <Paper      
        elevation={3}
        
        >            
        {[{
            icon: '🟢',
            desc: 'ว่าง'
          }, {
            icon: '🟡',
            desc: 'เป็นที่นิยม'
          }, {
            icon: '🟠',
            desc: 'เริ่มหนาแน่น'
          }, {
            icon: '🟤',
            desc: 'เต็ม'
          }].map(c => (<Grid key={c.icon} container wrap="nowrap" spacing={2}>
          <Grid item>
            <Typography variant='h1'>{c.icon}</Typography>
          </Grid>
          <Grid item xs>
            <Typography variant='h1'>{c.desc}</Typography>
          </Grid>
        </Grid>)
          )}
            
        </Paper>
    </Box>
  );
}